import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SubPageBlueprint } from '@backstage/frontend-plugin-api';
import { Content } from '@backstage/core-components';

const permissionsSettingsPage = SubPageBlueprint.make({
  name: 'permissions',
  attachTo: { id: 'page:user-settings', input: 'pages' },
  params: {
    path: 'permissions',
    title: 'Permissions',
    loader: () =>
      import('./MyPermissions').then(m => (
        <Content>
          <m.MyPermissions />
        </Content>
      )),
  },
});

export const userSettingsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [permissionsSettingsPage],
});

/*
 * Same-id override of `sub-page:user-settings/general`. `pluginId: 'user-settings'`
 * + name `general` gives the id plugin-user-settings registers for its General
 * subpage, so this replaces it rather than adding a tab. It renders a General
 * page identical to the stock one except the Appearance card drops the theme
 * toggle — the stopgap in ./GeneralSettingsPage.tsx (AB#28218). Path/title/Content
 * wrapper match the stock loader.
 */
const generalSettingsOverride = SubPageBlueprint.make({
  name: 'general',
  attachTo: { id: 'page:user-settings', input: 'pages' },
  params: {
    path: 'general',
    title: 'General',
    loader: () =>
      import('./GeneralSettingsPage').then(m => (
        <Content>
          <m.GeneralSettingsPage />
        </Content>
      )),
  },
});

export const userSettingsGeneralModule = createFrontendModule({
  pluginId: 'user-settings',
  extensions: [generalSettingsOverride],
});
